import { dew as _gatherSequenceExpressions2Dew } from "./gatherSequenceExpressions.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = toSequenceExpression;
  var _gatherSequenceExpressions = _gatherSequenceExpressions2Dew();
  function toSequenceExpression(nodes, scope) {
    if (!(nodes != null && nodes.length)) return;
    const declars = [];
    const result = (0, _gatherSequenceExpressions.default)(nodes, scope, declars);
    if (!result) return;
    for (const declar of declars) {
      scope.push(declar);
    }
    return result;
  }

  //# sourceMappingURL=toSequenceExpression.js.map
  return exports;
}